import { WorkOrderAssetTreeType } from '@atom/types/work';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import classes from '../workOrderDetailPdfReport.module.css';

interface Props {
  workOrderAsset: WorkOrderAssetTreeType;
  header: string;
}

const AttributesTable = ({ workOrderAsset, header }: Props) => {
  const renderAttributeRow = () => {
    const { attributeGroups, attributes } = workOrderAsset;
    const group = attributeGroups.filter(
      attributeGroup => attributeGroup.name === header,
    );
    const attributeGroupIds = group[0]?.attributes ? group[0]?.attributes : [];
    return attributeGroupIds.map(key => {
      if (attributes[key]) {
        return (
          <tr className={classes.textboxTableRow}>
            <td
              className={classes.textboxTableRowTitle}
              style={{ width: '16rem' }}
            >
              {attributes[key].name}:
            </td>
            <td className={classes.value}>
              {attributeDisplayUtility.display(
                attributes[key].value,
                attributes[key].dataType,
                attributes[key].unit,
                !!attributes[key].changeId,
                attributes[key].newValue,
              )}
            </td>
          </tr>
        );
      }
      return <></>;
    });
  };

  return (
    <table className={classes.collapseBorder}>
      <thead>
        <tr>
          <th className={classes.textboxTableTitle} colSpan={2}>
            {header}
          </th>
        </tr>
      </thead>
      <tbody className={classes.content}>{renderAttributeRow()}</tbody>
    </table>
  );
};

export default AttributesTable;
